import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { soundService } from '../../services';
import { gameStore } from '../../store/gameStore';
import { loadingStore } from '../../store/loadingStore';
import { AppDefaultValuesEnum, RtlLanguages } from '../../enums';
import { useAssetsLoadedState } from '../../hooks/useAssetsLoadedState';

import { LoadingWrapper } from '../../components';
import LoadingContent from './loadingContent';
import { translationService } from '../../services/translationService';
import { DefaultQueryParams } from '../../constants/defaultQueryParams';
import { parseQuery } from '../../helpers/parseQuery';
import { popupStore } from '../../store/popupStore';
import { TranslationContext } from '../../contexts/translation';
import IntroContent from '../GameIntro/IntroContent';
import { PopupTypes } from '../../constants/popupTypes';
import { gameDefaultTranslations } from '../../constants/gameDefaultTranslations';
import { applicationStore } from '../../store/applicationStore';

export let bodyRef;
export let translations = {};

const LoadingContainer = observer(({ children }) => {
  const { reconnect } = popupStore;

  const { assetsIsLoaded } = useAssetsLoadedState(bodyRef);
  const { gameLoading, timerFinished, updateLoading, progress, setIsSoundsLoaded } = loadingStore;
  const { isJackpotSocketConnected } = applicationStore;
  const query = parseQuery(window.location.search);
  const lang = query[DefaultQueryParams.Culture] || AppDefaultValuesEnum.LANGUAGE;
  const partnerId = query[DefaultQueryParams.PartnerId];

  // eslint-disable-next-line react-hooks/exhaustive-deps

  const fetchTranslation = useCallback(async () => {
    if (RtlLanguages.includes(lang)) {
      document.documentElement.setAttribute('dir', 'rtl');
    }
    try {
      const {
        data: { result },
      } = await translationService.getTranslations({
        applicationId: AppDefaultValuesEnum.APPLICATION_ID,
        code: lang,
        partnerId,
      });
      translations = Object.values(result).length ? result : gameDefaultTranslations;
      gameStore.setTranslationsTextInCanvas(translations);
      updateLoading({ isTranslationsLoaded: true });
    } catch (e) {
      updateLoading({ isTranslationsLoaded: true });
      gameStore.setTranslationsTextInCanvas(gameDefaultTranslations);
      translations = gameDefaultTranslations;
    }
  }, [lang, partnerId, updateLoading]);

  const fetchSound = useCallback(async () => {
    soundService.loadResource();
  }, []);

  useEffect(async () => {
    bodyRef = document.querySelector('body');
    (function () {
      fetchTranslation();
      fetchSound();
    })();
  }, [updateLoading]);

  useEffect(() => {
    loadingStore.setIsAssetsLoaded(assetsIsLoaded);
  }, [assetsIsLoaded]);

  return (
    <TranslationContext.Provider value={translations}>
      {gameLoading ||
      !timerFinished ||
      !assetsIsLoaded ||
      reconnect ||
      !isJackpotSocketConnected ||
      progress !== 100 ? (
        <>
          {/* <Loading */}
          {/*  progress={progress} */}
          {/*  logo={Logo} */}
          {/*  withoutProgressRenderer={reconnect} */}
          {/*  withoutProviderRenderer={reconnect} */}
          {/* /> */}
          <LoadingWrapper containerRef={bodyRef}>
            <LoadingContent />
          </LoadingWrapper>
        </>
      ) : (
        window.parent.postMessage({ name: PopupTypes.gameReady }, '*')
      )}
      {children}
    </TranslationContext.Provider>
  );
});

export default LoadingContainer;
